import css from 'styled-jsx/css';

const styles = css.global`.shr-btn-red {
  border: none;
  border-radius: 4px;

  background: none;
  background-color: #cc0000;
  color: #fff;

  cursor: pointer;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  height: 50px;
  width: 168px;
  font-size: 18px;
  padding: 0 8px;
  box-sizing: border-box;
  font-family: 'SantanderText';

  transition: background-color 350ms linear;
}

.shr-btn-red.wide {
  width: 100%;
  max-width: 600px;
}

.shr-btn-red:hover {
  background-color: #f14c4c;
}

@media (min-width: 992px) {
  .shr-btn-red {
    width: 180px;
  }

  .shr-btn-red.wide {
    max-width: 180px;
  }
}
`;

export default styles;